import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { ServicePackagePurchase } from '@beautyapp/core';
import { PackageRefundModalComponent } from './package-refund-modal.component';

/**
 * Opens the refund/cancellation modal for a partially-used package (beaut-290).
 * The modal closes with `true` once a refund is committed; callers should reload
 * their purchase list on a truthy `afterClose`.
 */
export function openPackageRefundModal(
  modalService: NzModalService,
  purchase: ServicePackagePurchase
): NzModalRef<PackageRefundModalComponent, boolean> {
  return modalService.create<
    PackageRefundModalComponent,
    { purchase: ServicePackagePurchase },
    boolean
  >({
    nzTitle: 'პაკეტის გაუქმება / თანხის დაბრუნება',
    nzContent: PackageRefundModalComponent,
    nzData: { purchase },
    nzWidth: 520,
    nzFooter: null,
  });
}
